module.exports = [
  {
    slug: "/eco",
    bgImage: require('../assets/Home/DAIF_Menu.jpg'),
    videoTransitionIn: require('../assets/03_ECO/DAIF_Eco_In.mp4'),
    videoBgLoop: require('../assets/03_ECO/DAIF_Eco_Loop_Comp.mp4'),
    bgImage2: require('../assets/03_ECO/DAIF_Eco_Clean.jpg'),
    ctas: [
      {
        url: "/",
        width: "4%",
        height: "8%",
        top: "86.5%",
        left: "3.4%",
      },
      {
        url: "/eco/1in",
        width: "20%",
        height: "4.5%",
        top: "70%",
        left: "76.4%",
      },
      {
        url: "/eco/2in",
        width: "20%",
        height: "4.5%",
        top: "74.6%",
        left: "76.4%",
      },
      {
        url: "/eco/3in",
        width: "20%",
        height: "4.5%",
        top: "79.2%",
        left: "76.4%",
      },
      {
        url: "/eco/4in",
        width: "20%",
        height: "4.5%",
        top: "83.9%",
        left: "76.4%",
      },
      {
        url: "/eco/5in",
        width: "20%",
        height: "4.5%",
        top: "88.5%",
        left: "76.4%",
      },
    ],
  },
  {
    slug: "/ecob",
    bgImage: require('../assets/03_ECO/DAIF_Eco_Clean.jpg'),
    videoTransitionIn: require('../assets/03_ECO/DAIF_Eco_Loop_Comp.mp4'),
    videoBgLoop: require('../assets/03_ECO/DAIF_Eco_Loop_Comp.mp4'),
    bgImage2: require('../assets/03_ECO/DAIF_Eco_Clean.jpg'),
    ctas: [
      {
        url: "/",
        width: "4%",
        height: "8%",
        top: "86.5%",
        left: "3.4%",
      },
      {
        url: "/eco/1in",
        width: "20%",
        height: "4.5%",
        top: "70%",
        left: "76.4%",
      },
      {
        url: "/eco/2in",
        width: "20%",
        height: "4.5%",
        top: "74.6%",
        left: "76.4%",
      },
      {
        url: "/eco/3in",
        width: "20%",
        height: "4.5%",
        top: "79.2%",
        left: "76.4%",
      },
      {
        url: "/eco/4in",
        width: "20%",
        height: "4.5%",
        top: "83.9%",
        left: "76.4%",
      },
      {
        url: "/eco/5in",
        width: "20%",
        height: "4.5%",
        top: "88.5%",
        left: "76.4%",
      },
    ],
  },

  {
    slug: "/eco/1in",
    bgImage: require('../assets/03_ECO/DAIF_Eco_Clean.jpg'),
    videoTransitionIn: require('../assets/03_ECO/DAIF_Eco_Screen1_in.mp4'),
    videoTransitionInEnd: require('../assets/03_ECO/DAIF_Eco_Screen1_in-end.jpg'),
    videoBgLoop: "",
    bgImage2: require('../assets/03_ECO/DAIF_Eco_Screen1_in-end.jpg'),
    ctas: [],
    autoNavigateURL: "/eco/1",
  },
  {
    slug: "/eco/2in",
    bgImage: require('../assets/03_ECO/DAIF_Eco_Clean.jpg'),
    videoTransitionIn: require('../assets/03_ECO/DAIF_Eco_Screen2_in.mp4'),
    videoTransitionInEnd: require('../assets/03_ECO/DAIF_Eco_Screen2_in-end.jpg'),
    videoBgLoop: "",
    bgImage2: require('../assets/03_ECO/DAIF_Eco_Screen2_in-end.jpg'),
    ctas: [],
    autoNavigateURL: "/eco/2",
  },
  {
    slug: "/eco/3in",
    bgImage: require('../assets/03_ECO/DAIF_Eco_Clean.jpg'),
    videoTransitionIn: require('../assets/03_ECO/DAIF_Eco_Screen3_in.mp4'),
    videoTransitionInEnd: require('../assets/03_ECO/DAIF_Eco_Screen3_in-end.jpg'),
    videoBgLoop: "",
    bgImage2: require('../assets/03_ECO/DAIF_Eco_Screen3_in-end.jpg'),
    ctas: [],
    autoNavigateURL: "/eco/3",
  },
  {
    slug: "/eco/4in",
    bgImage: require('../assets/03_ECO/DAIF_Eco_Clean.jpg'),
    videoTransitionIn: require('../assets/03_ECO/DAIF_Eco_Screen4_in.mp4'),
    videoTransitionInEnd: require('../assets/03_ECO/DAIF_Eco_Screen4_in-end.jpg'),
    videoBgLoop: "",
    bgImage2: require('../assets/03_ECO/DAIF_Eco_Screen4_in-end.jpg'),
    ctas: [],
    autoNavigateURL: "/eco/4",
  },
  {
    slug: "/eco/5in",
    bgImage: require('../assets/03_ECO/DAIF_Eco_Clean.jpg'),
    videoTransitionIn: require('../assets/03_ECO/DAIF_Eco_Screen4_in.mp4'),
    videoTransitionInEnd: require('../assets/03_ECO/DAIF_Eco_Screen4_in-end.jpg'),
    videoBgLoop: "",
    bgImage2: require('../assets/03_ECO/DAIF_Eco_Screen4_in-end.jpg'),
    ctas: [],
    autoNavigateURL: "/eco/5",
  },

  {
    slug: "/eco/1",
    bgImage: require('../assets/03_ECO/DAIF_Eco_Screen1_in-end.jpg'),
    videoTransitionIn: require('../assets/03_ECO/03_DAIF_Eco_01_01.mp4'),
    videoTransitionInEnd: require('../assets/03_ECO/03_DAIF_Eco_01_01_end.jpg'),
    videoBgLoop: "",
    bgImage2: require('../assets/03_ECO/03_DAIF_Eco_01_01_end.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/ecob",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "7.4%",
      },
      {
        url: "/eco/1/1",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "93.3%",
      },
    ],
  },
  {
    slug: "/eco/1/1",
    bgImage: require('../assets/03_ECO/03_DAIF_Eco_01_01_end.jpg'),
    videoTransitionIn: require('../assets/03_ECO/03_DAIF_Eco_01_02.mp4'),
    videoTransitionInEnd: require('../assets/03_ECO/03_DAIF_Eco_01_02_end.jpg'),
    videoBgLoop: "",
    bgImage2: require('../assets/03_ECO/03_DAIF_Eco_01_02_end.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/ecob",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "7.4%",
      },
      {
        url: "/eco/1",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "89.7%",
      },
      {
        url: "/eco/1/2",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "93.3%",
      },
    ],
  },
  {
    slug: "/eco/1/2",
    bgImage: require('../assets/03_ECO/03_DAIF_Eco_01_02_end.jpg'),
    videoTransitionIn: require('../assets/03_ECO/03_DAIF_Eco_01_03.mp4'),
    videoTransitionInEnd: require('../assets/03_ECO/03_DAIF_Eco_01_03_end.jpg'),
    videoBgLoop: "",
    bgImage2: require('../assets/03_ECO/03_DAIF_Eco_01_03_end.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/ecob",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "7.4%",
      },
      {
        url: "/eco/1/1",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "89.7%",
      },
      {
        url: "/eco/1/3",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "93.3%",
      },
    ],
  },
  {
    slug: "/eco/1/3",
    bgImage: require('../assets/03_ECO/03_DAIF_Eco_01_03_end.jpg'),
    videoTransitionIn: require('../assets/03_ECO/03_DAIF_Eco_01_04.mp4'),
    videoTransitionInEnd: require('../assets/03_ECO/03_DAIF_Eco_01_04_end.jpg'),
    videoBgLoop: "",
    bgImage2: require('../assets/03_ECO/03_DAIF_Eco_01_04_end.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/ecob",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "7.4%",
      },
      {
        url: "/eco/1/2",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "93.3%",
      },
    ],
  },
  {
    slug: "/eco/2",
    bgImage: require('../assets/03_ECO/DAIF_Eco_Screen2_in-end.jpg'),
    videoTransitionIn: require('../assets/03_ECO/03_DAIF_Eco_02_AMD.mp4'),
    videoTransitionInEnd: require('../assets/03_ECO/03_DAIF_Eco_02_AMD_end.jpg'),
    videoBgLoop: "",
    bgImage2: require('../assets/03_ECO/03_DAIF_Eco_02_AMD_end.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/ecob",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "7.4%",
      }
    ],
  },
  {
    slug: "/eco/3",
    bgImage: require('../assets/03_ECO/DAIF_Eco_Screen3_in-end.jpg'),
    videoTransitionIn: require('../assets/03_ECO/03_DAIF_Eco_03_INTEL.mp4'),
    videoTransitionInEnd: require('../assets/03_ECO/03_DAIF_Eco_03_INTEL_end.jpg'),
    videoBgLoop: "",
    bgImage2: require('../assets/03_ECO/03_DAIF_Eco_03_INTEL_end.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/ecob",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "7.4%",
      }
    ],
  },
  {
    slug: "/eco/4",
    bgImage: require('../assets/03_ECO/DAIF_Eco_Screen4_in-end.jpg'),
    videoTransitionIn: require('../assets/03_ECO/03_DAIF_Eco_04_LLAMA.mp4'),
    videoTransitionInEnd: require('../assets/03_ECO/03_DAIF_Eco_04_LLAMA_end.jpg'),
    videoBgLoop: "",
    bgImage2: require('../assets/03_ECO/03_DAIF_Eco_04_LLAMA_end.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/ecob",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "7.4%",
      }
    ],
  },
  {
    slug: "/eco/5",
    bgImage: require('../assets/03_ECO/DAIF_Eco_Screen4_in-end.jpg'),
    videoTransitionIn: require('../assets/03_ECO/03_DAIF_Eco_05_HUGGING.mp4'),
    videoTransitionInEnd: require('../assets/03_ECO/03_DAIF_Eco_05_HUGGING_end.jpg'),
    videoBgLoop: "",
    bgImage2: require('../assets/03_ECO/03_DAIF_Eco_05_HUGGING_end.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/ecob",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "7.4%",
      }
    ],
  },
  
]